export default __webpack_public_path__ + "maps-examples-inset-map-1200-1a48b6e0a900837003ca7d9ff0aed311.png";